import React, {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {gameClockSelector, loadedPresentationSelector} from '../../store/selectors/presentation.selectors';
import {timerSelector} from '../../store/selectors/timer.selector';

function Timer(): ReactElement | null {
    const timeElapsed = useSelector(timerSelector);
    const gameClock = useSelector(gameClockSelector);
    const presentation = useSelector(loadedPresentationSelector);

    function calculateTime(timeElapsed: number, gameClock: number, isGamificationOn: boolean): string {
        if (isGamificationOn) {
            const numOfSec = gameClock * 60 - timeElapsed;
            const minutes = Math.floor(numOfSec / 60);
            const seconds = numOfSec % 60;
            return minutes > 0 || seconds > 0 ? `${minutes}:${seconds > 9 ? seconds : `0${seconds}`}` : "Time's up";
        }
        return '';
    }

    if (gameClock && presentation?.gameConfig.isGamificationOn) {
        return (
            <span>
                {timeElapsed && timeElapsed !== 0 && gameClock
                    ? calculateTime(timeElapsed, gameClock, presentation.gameConfig.isGamificationOn)
                    : ''}
            </span>
        );
    }

    return null;
}

export default Timer;
